/**
 * columnDenylist — единый helper для фильтрации технических колонок
 * из user-facing column pickers (Search + Generation).
 *
 * UX-J10 (2026-07-28): пользователь НЕ должен видеть blob/sha256/internal fields
 * в pickers. Денайлист ОБЯЗАН применяться и на Search, и на Generation —
 * для консистентности "original file columns + enriched/generated keys only".
 *
 * Использование:
 *   import { isUserVisibleColumn, filterUserVisibleColumns } from '@/lib/columnDenylist';
 *   const cols = filterUserVisibleColumns(allColumns); // ['name', 'price', ...]
 *
 * Денайлист case-insensitive, по подстроке/whole match.
 */
const DENY_SUBSTRINGS: readonly string[] = [
  'blob',
  'sha256',
  'sha1',
  'md5',
  'hash',
  'storage_path',
  'raw_metadata',
  'error_count',
  'total_rows',
  'content_hash',
  'file_path',
  'internal_id',
  'etag',
  'checksum',
  'trace_id',
  'raw_html',
  'fetch_log',
  'pipeline_run_id',
];

const DENY_EXACT: ReadonlySet<string> = new Set([
  'id',
  'uuid',
  'created_at',
  'updated_at',
  'deleted_at',
  'is_deleted',
  'is_active',
  'is_test',
  '_internal',
  '__class__',
  'pydantic_field',
]);

/** True, если колонка должна быть СКРЫТА от пользователя. */
export function isDeniedColumn(name: string): boolean {
  if (!name) return true;
  const lower = name.toLowerCase().trim();
  if (!lower) return true;
  if (DENY_EXACT.has(lower)) return true;
  for (const sub of DENY_SUBSTRINGS) {
    if (lower.includes(sub)) return true;
  }
  return false;
}

/** Отфильтровать список колонок, оставив только user-visible. */
export function filterUserVisibleColumns(columns: readonly string[]): string[] {
  return columns.filter((c) => !isDeniedColumn(c));
}
